import { containsMaskedPhoneNumber, isMaskedPhoneNumber, shouldMaskPhoneNumbers } from 'src/plugins/helpers/phone-masking'

/**
 * The company channel with full phone numbers (api-core Company::fullPhoneNumbersChannelName). Only Admins
 * and Supervisors may subscribe, and only an account that hides numbers from agents sends anything on it.
 * @param {number} companyId
 * @returns {string}
 */
export const fullPhoneNumbersChannelName = (companyId) => `company-${companyId}.full-numbers`

/**
 * Whether the user should take live updates from the full numbers channel: the account hides numbers
 * from agents and the user sees them in full anyway, as an Admin or a Supervisor.
 * @param {Object|null} company
 * @param {string[]|null} userRoles
 * @returns {boolean}
 */
export const receivesFullPhoneNumbers = (company, userRoles) => {
  return !!company?.hide_phone_numbers_from_agents && !shouldMaskPhoneNumbers(company, userRoles)
}

/**
 * Whether a company channel update carries a number masked for agents, alone or in the contact's name, so the
 * full numbers channel sent the same update in full (api-core PhoneMaskingHelper::maskForCompanyChannel).
 * @param {Object|null} event
 * @returns {boolean}
 */
export const carriesMaskedPhoneNumber = (event) => {
  return [
    event?.communication?.lead_number,
    event?.contact?.phone_number,
    event?.audit?.from,
    event?.audit?.to,
    event?.mention?.contact?.phone_number
  ].some(isMaskedPhoneNumber) || [
    event?.contact?.name,
    event?.mention?.contact?.name
  ].some(containsMaskedPhoneNumber)
}

/**
 * Whether Echo holds the private channel, subscribed or still subscribing.
 * @param {Object|null} echo
 * @param {string} name
 * @returns {boolean}
 */
export const isChannelOpen = (echo, name) => !!echo?.connector?.channels?.['private-' + name]

/**
 * Whether the server confirmed the subscription to the private channel. False while reconnecting.
 * @param {Object|null} echo
 * @param {string} name
 * @returns {boolean}
 */
export const isChannelSubscribed = (echo, name) => echo?.connector?.pusher?.channel('private-' + name)?.subscribed === true
